// extracted by mini-css-extract-plugin
export default {"VirtualRoomMeetingButton":"VirtualRoomMeetingButton-module-ff0270bacf12a25470f0"};